export default({
	data: function () {
		return {
            error: '',
            is_ok: false,

            auth_on: false,

            user_name: { value: '', error: false },
            password: { value: '', error: false },
		};
	},

	methods: {
        auth: function () {
            if (this.auth_on)
                return false;

            var params = {};
            params.user_name = this.user_name.value;
            params.password = this.password.value;

            this.auth_on = true;
                this.$http.post('/account/auth', params).then(response => {
                var body = response.body;
				if (body.response_status == 0) {
                    this.password.error = false;
                    this.user_name.error = false;
                    this.error = '';

                    this.is_ok = true;

					document.location.href = "/";
				} else {
					this.password.value = '';

                    this.error = body.error_message;
                    this.password.error = true;
                    this.user_name.error = true;

                }

                this.auth_on = false;
            }, error => {
                this.error = 'Something went wrong with our server. Please contact System Administrator (code ' + error.status + ')';
                this.auth_on = false;
            });
		}
	}
});




// WEBPACK FOOTER //
// ./src/components/external/login/login.js